/**
 * SDK Body State Management
 * Manages body styles and classes when SDK is in fullscreen mode
 */

const SDK_ACTIVE_CLASS = 'sdk-active';

/**
 * Enable fullscreen SDK mode on body
 * Hides overflow and adds SDK active class
 */
export const enableSDKFullscreen = (): void => {
    document.body.style.overflow = 'hidden';
    document.body.classList.add(SDK_ACTIVE_CLASS);
};

/**
 * Disable fullscreen SDK mode on body
 * Restores overflow and removes SDK active class
 */
export const disableSDKFullscreen = (): void => {
    document.body.style.overflow = 'auto';
    document.body.classList.remove(SDK_ACTIVE_CLASS);
};

/**
 * Check if SDK fullscreen mode is active
 */
export const isSDKFullscreenActive = (): boolean => {
    return document.body.classList.contains(SDK_ACTIVE_CLASS);
};
